import createReactComponent from "../createReactComponent";
import defaultAttributes from "../defaultAttributes";
var Loader = createReactComponent("Loader", ["svg", defaultAttributes, [["line", {
  x1: "12",
  y1: "2",
  x2: "12",
  y2: "6",
  key: "53aro4"
}], ["line", {
  x1: "12",
  y1: "18",
  x2: "12",
  y2: "22",
  key: "1slx9a"
}], ["line", {
  x1: "4.93",
  y1: "4.93",
  x2: "7.76",
  y2: "7.76",
  key: "91at3k"
}], ["line", {
  x1: "16.24",
  y1: "16.24",
  x2: "19.07",
  y2: "19.07",
  key: "1jjqbg"
}], ["line", {
  x1: "2",
  y1: "12",
  x2: "6",
  y2: "12",
  key: "1o7g50"
}], ["line", {
  x1: "18",
  y1: "12",
  x2: "22",
  y2: "12",
  key: "8ldd2x"
}], ["line", {
  x1: "4.93",
  y1: "19.07",
  x2: "7.76",
  y2: "16.24",
  key: "1k6nnb"
}], ["line", {
  x1: "16.24",
  y1: "7.76",
  x2: "19.07",
  y2: "4.93",
  key: "tii48m"
}]]]);
export default Loader;